import { FC } from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { ReadonlyCustomerList } from 'components/organisms/ReadonlyCustomerList';
import { CustomerForForms } from 'types/customer';
import { createConditionName } from 'types/releaseTask';
import { DATE_FORMAT } from 'utils/dateUtils';
import { ReleaseTaskFormField } from '../../../../../../types/releaseTask';

type Props = {
  mode: '登録' | '更新';
  values: ReleaseTaskFormField;
  handleBack: () => void;
  handleSubmit: () => void;
  releaseEnvironments: { id: string; name: string }[];
  targetGroupList: { id: string; name: string }[];
  shouldShowCustomerList: boolean;
  selectedCustomers: CustomerForForms[];
};

export const TaskRegistrationConfirmModalView: FC<Props> = ({
  mode,
  values,
  handleBack,
  handleSubmit,
  releaseEnvironments,
  targetGroupList,
  shouldShowCustomerList,
  selectedCustomers,
}) => (
  <form onSubmit={handleSubmit}>
    <ModalContent maxHeight="90vh">
      <ModalHeader p="40px">タスクの{mode}</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>タスク名</FormLabel>
            <Input
              type="text"
              value={values.taskName}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          {mode === '登録' && (
            <>
              <FormLabel>環境名</FormLabel>
              {releaseEnvironments.map(
                (list) =>
                  values.version === list.id && (
                    <Stack key={list.id}>
                      <Input
                        type="text"
                        value={list.name}
                        variant="flushed"
                        isReadOnly
                      />
                    </Stack>
                  ),
              )}
            </>
          )}
          <Flex flexDirection="row" gap={5} alignItems="start">
            <Box>
              <FormControl>
                <FormLabel>タスク開始日</FormLabel>
                <Input
                  type="text"
                  value={format(values.startsAt, DATE_FORMAT.DATE_TIME)}
                  width="240px"
                  variant="flushed"
                  isReadOnly
                  isTruncated
                />
              </FormControl>
            </Box>
            <Box w="20px" pt="40px">
              <Text as="span">〜</Text>
            </Box>
            <Box>
              <FormControl>
                <FormLabel>タスク終了日</FormLabel>
                <Input
                  type="text"
                  value={format(values.endsAt, DATE_FORMAT.DATE_TIME)}
                  width="240px"
                  variant="flushed"
                  isReadOnly
                  isTruncated
                />
              </FormControl>
            </Box>
          </Flex>
          <FormControl>
            <FormLabel>ターゲットグループ</FormLabel>
            {targetGroupList.map(
              (list) =>
                values.group === list.id && (
                  <Stack key={list.id}>
                    <Input
                      type="text"
                      value={list.name}
                      variant="flushed"
                      isReadOnly
                    />
                  </Stack>
                ),
            )}
          </FormControl>
          <Box mt="40px">
            <Heading as="h5" size="sm">
              配信対象顧客
            </Heading>
            <Text fontSize="md">{createConditionName(values.condition)}</Text>
          </Box>
          <Box mt="40px">
            {shouldShowCustomerList && (
              <ReadonlyCustomerList
                selectedCustomers={selectedCustomers}
                selectedCustomersLength={selectedCustomers.length}
              />
            )}
          </Box>
        </Stack>
        <Text align="center" fontWeight="bold" mt="60px">
          上記の内容でタスクを{mode}しますか？
        </Text>
      </ModalBody>
      <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
        <Button
          w="140px"
          variant="outline"
          colorScheme="blackAlpha"
          onClick={handleBack}
        >
          入力画面に戻る
        </Button>
        <Button w="140px" colorScheme="blackAlpha" type="submit">
          {mode}
        </Button>
      </ModalFooter>
    </ModalContent>
  </form>
);
